module.exports = {
    REACT_APP_API_URL: 'http://localhost:5000/api',
    REACT_APP_ENV: 'development',
    ENCRYPTION_KEY : 'your-secret-key'
  };